import React from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../config'

/**
 * The official Apple and Google badges, in the visitor's language. Both stores forbid
 * altering the artwork, so they are only ever scaled, and to the same height: 40px is
 * Apple's minimum on screen. The Google files are trimmed of their transparent padding
 * so the two line up.
 */
const StoreBadges: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { locale, t } = useLocale()

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
        <img
          src={`/img/badges/app-store-${locale}.svg`}
          alt={t('apps.appStoreAlt')}
          className="h-10 w-auto"
        />
      </a>
      <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
        <img
          src={`/img/badges/google-play-${locale}.png`}
          alt={t('apps.googlePlayAlt')}
          className="h-10 w-auto"
        />
      </a>
    </div>
  )
}

export default StoreBadges
